export const budgetSummary = {
  'Budget Summary': 'Resumen del presupuesto',
  'Go to facial recognition': 'Seguir con el reconocimiento facial',
  "Go to {{name}}'s facial recognition":
    'Seguir al reconocimiento facial de {{name}}',
  'Hello {{name}}!': '¡Hola {{name}}!',
  'Legal guardian data': 'Datos del responsable legal',
  'Please, verify the information about your budget below to continue':
    'Por favor, verificá la información de tu presupuesto abajo para continuar.',
  'Service taker data': 'Datos del tomador del servicio',
  'The facial recognition process must be performed by the legal guardian':
    'El proceso de reconocimiento facial debe ser realizado por el responsable legal',
  'We are very happy that you are on this journey with us! Please, verify the information about your budget below to continue':
    '¡Estamos muy felices de que estés con nosotros en este camino! Por favor, verificá la información de tu presupuesto abajo para continuar.',
};
